
export class BC_detail {
    id_detail_bc:number;
    num_bc:any = "000001/DIR";
    bc_id:number;
    motif_rejet:any;
    etat_detail_bc : any = "ACT"; 


   
    constructor(id_detail_bc:number){
           
    }
}
